import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App.js';

import { Provider } from 'react-redux';
import logger from "redux-logger";
import thunk from "redux-thunk";
import reducer from './Reducers/reducers.js';
import { createStore, applyMiddleware } from 'redux';
//import reportWebVitals from './reportWebVitals';

const store = createStore(reducer, applyMiddleware(thunk, logger));


ReactDOM.render(
	<Provider store ={store}>
		<App />
	</Provider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
